<app-layout>
  <div class="finish-sign-up-component">
    <app-page-header
      title="Finalizar cadastro"
      titleIcon="pi pi-user-plus"
      subtitle="Preencha os campos abaixo para finalizar o cadastro.
  "
      [headerFlexWrap]="false">
    </app-page-header>
    <app-finish-sign-up-form
      [tokenPayload]="tokenPayload"
      [userData]="currentUserInfo"
      [isLoading]="isLoading"
      (formSubmitClick)="handleFormSubmit($event)" />
  </div>
</app-layout>
